import React from 'react';
import img1 from '../../../../../img/how-it-works-assessment/book-assessment-img.jpg';
import img2 from '../../../../../img/how-it-works-assessment/complete-assessor-img.png';
import img3 from '../../../../../img/how-it-works-assessment/cd-usb-img.png';
import img4 from '../../../../../img/how-it-works-assessment/assessment-mac-img.png';
import img5 from '../../../../../img/how-it-works-assessment/assessment-certificate-img.png';

const IBSLAssessment = () => (
  <div className='l-container l-container--x-narrow'>
    <ul className='progression-list'>
      <li className='island island--outline js-inview is-inview'>
        <h2>1. Book Assessment</h2>
        <img src={img1} alt='Book assessment' />
      </li>

      <li className='island island--outline js-inview is-inview'>
        <h2>2. Complete assessment with tutor</h2>
        <img src={img2} alt='Complete assessment' />
      </li>

      <li className='island island--outline js-inview is-inview'>
        <h2>3. Tutor copies assessment onto a CD or a USB stick</h2>
        <img src={img3} alt='Tutor actions' />
      </li>

      <li className='island island--outline js-inview is-inview'>
        <h2>4. Tutors sends assessment to IBSL</h2>
        <img src={img4} alt='Sent to iBSL' />
      </li>

      <li className='island island--outline js-inview is-inview'>
        <h2>5. Qualification!</h2>
        <img src={img5} alt='Qualification' />
      </li>
    </ul>
  </div>
);

export default IBSLAssessment;



// WEBPACK FOOTER //
// ./src/views/Main/Tour/AssessmentAndEvidences/IBSLAssessment/index.js